import { createAction, createReducer } from '@reduxjs/toolkit';
import { firstDayOfMonth, today } from '../../../../../utils/dates';
import { IInitialState } from './interface';

const INITIAL_STATE: IInitialState = {
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  partner: 0,
  fare: 0,
  initialDate: firstDayOfMonth(),
  finalDate: today(),
  searched: {
    partner: 0,
    fare: 0,
    initialDate: firstDayOfMonth(),
    finalDate: today(),
  },
};

export const settingFilter = createAction('@limitApp/filter/SETTING_FILTER');

export const setPartnerFilterOptions = createAction<any>(
  '@limitApp/filter/SET_PARTNER_FILTER_OPTION'
);
export const setFareFilterOptions = createAction<any>(
  '@limitApp/filter/SET_FARE_FILTER_OPTION'
);
export const setInitialDateFilterOptions = createAction<any>(
  '@limitApp/filter/SET_INITIAL_DATE_FILTER_OPTION'
);
export const setFinalDateFilterOptions = createAction<any>(
  '@limitApp/filter/SET_FINAL_DATE_FILTER_OPTION'
);
export const setSearched = createAction<any>('@limitApp/filter/SET_SEARCHED');

export const gotError = createAction('@limitApp/filter/GOT_ERROR');

const limitFilterReducer = createReducer(INITIAL_STATE, {
  [settingFilter.type]: (state) => ({
    ...state,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [setPartnerFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    partner: action.payload,
  }),
  [setFareFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    fare: action.payload,
  }),
  [setInitialDateFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    initialDate: action.payload,
  }),
  [setFinalDateFilterOptions.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    finalDate: action.payload,
  }),
  [setSearched.type]: (state, action) => ({
    ...state,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    searched: {
      partner: action.payload.partner,
      fare: action.payload.fare,
      initialDate: action.payload.initialDate,
      finalDate: action.payload.finalDate,
    },
  }),
  [gotError.type]: (state) => ({
    ...state,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
});

export default limitFilterReducer;
